import Content from '../../../../../../shared/types/enums/content';
import EpgEvent from '../../../../../../shared/classes/epgEvent';
import HorizontalCard from '../../../../elements/card/horizontalCard';
import List from '../../list';
import MainContext from '../../../../../../shared/components/utils/context/mainContext';
import RailProps from '../../../../../../shared/types/props/rail';
import RegularEvent from '../../../../../../shared/classes/regularEvent';
import VerticalCard from '../../../../elements/card/verticalCard';
import goToContent from '../../../../../../shared/actions/content/goToContent';
import { RailDisplayMode } from '../../../../../../shared/types/enums/rail';
import { recordingSelector } from '../../../../../../shared/store/slices/recordings.slice';
import { useAppSelector } from '../../../../../../shared/store/hooks';
import { useState, useEffect, useContext } from 'react';

function RecordingsRail({ list }: RailProps) {
  const {
    data,
    displayMode,
    focus: listFocus,
    deleteRail,
    onClick,
    updateData,
  } = list;
  const [eventsData, setData] = useState(data);
  const { finished, pending } = useAppSelector(recordingSelector);
  const { complete } = useContext(MainContext);

  useEffect(() => {
    setData(data);
  }, [data]);

  useEffect(() => {
    if (complete && eventsData?.length && !eventsData[0]?.dummy) {
      eventsData.forEach((item) => {
        let findEvent = pending.find((finalRecording) => {
          return finalRecording?.eventId === item?.eventId;
        });
        if (!findEvent) {
          findEvent = finished.find((finalRecording) => {
            return finalRecording?.eventId === item?.eventId;
          });
          if (!findEvent) {
            const data = eventsData.filter((event) => {
              return event?.id !== item?.id;
            });
            if (data.length) {
              updateData(data);
              setData(data);
              if (list?.setListIndex) {
                list?.setListIndex.current(0, -1);
              }
            } else {
              deleteRail();
            }
          }
        }
      });
    }
  }, [complete, finished, pending, eventsData, list]);

  return (
    <List {...list}>
      {(eventsData as (EpgEvent | RegularEvent | undefined)[])?.map(
        (item: EpgEvent | RegularEvent | undefined, index: number) => {
          if (!item) return;
          switch (displayMode) {
            case RailDisplayMode.PHOTO:
              if (item?.type === Content.EPG_EVENT) {
                return (
                  <HorizontalCard
                    key={index}
                    item={item as EpgEvent}
                    index={index}
                    onClick={() => onClick(item as EpgEvent, index, listFocus)}
                    releaseAction={() => goToContent(item)}
                  />
                );
              } else {
                if (item?.seasonNumber) {
                  return (
                    <HorizontalCard
                      key={index}
                      item={item as EpgEvent}
                      index={index}
                      releaseAction={() => {
                        goToContent(item);
                      }}
                    />
                  );
                }
                return (
                  <HorizontalCard
                    key={index}
                    item={item as RegularEvent}
                    index={index}
                    onClick={() =>
                      onClick(item as RegularEvent, index, listFocus)
                    }
                    releaseAction={() => goToContent(item)}
                  />
                );
              }

            case RailDisplayMode.POSTER:
              return (
                <VerticalCard
                  key={index}
                  item={item as RegularEvent}
                  index={index}
                  onClick={() =>
                    onClick(item as RegularEvent, index, listFocus)
                  }
                  releaseAction={() => goToContent(item)}
                />
              );
          }
        }
      )}
    </List>
  );
}

export default RecordingsRail;
